import { IconWarningSign16, LinkButton, TPlacement, TooltipDesktop } from '@cian/ui-kit';

import { FC } from 'react';

import { useCardComplaintContext } from 'shared/context/CardComplaintContext';

import { ControlWrapper } from '../ControlWrapper';

type ComplaintContainerProps = {
  tooltipPlacement?: TPlacement;
};

export const ComplaintContainer: FC<ComplaintContainerProps> = props => {
  const { tooltipPlacement = 'left' } = props;
  const { onModalOpen } = useCardComplaintContext();

  return (
    <ControlWrapper>
      <TooltipDesktop placement={tooltipPlacement} theme="black" title="Пожаловаться">
        <LinkButton
          beforeIcon={<IconWarningSign16 />}
          data-testid="ComplaintControl"
          size="XS"
          target="_blank"
          theme="stroke_secondary"
          onClick={onModalOpen}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
